import config from '../config';

export function dataURItoBlob(dataURI) {
  // convert base64 to raw binary data held in a string
  // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
  var byteString = atob(dataURI.split(',')[1]);

  // separate out the mime component
  var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

  // write the bytes of the string to an ArrayBuffer
  var ab = new ArrayBuffer(byteString.length);
  var ia = new Uint8Array(ab);
  for (var i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  //Old Code
  //write the ArrayBuffer to a blob, and you're done
  //var bb = new BlobBuilder();
  //bb.append(ab);
  //return bb.getBlob(mimeString);

  //New Code
  return new Blob([ab], { type: mimeString });
}

/**
 * @param {HTMLImageElement} image - Image File Object
 * @param {Object} crop - crop Object
 * @param {String} fileName - Name of the returned file in Promise
 */
export function getCroppedImg(image, crop, fileName) {
  const canvas = document.createElement('canvas');
  console.debug(image);
  const scaleX = image.naturalWidth / image.width;
  const scaleY = image.naturalHeight / image.height;
  canvas.width = crop.width;
  canvas.height = crop.height;
  const ctx = canvas.getContext('2d');

  ctx.drawImage(
    image,
    crop.x * scaleX,
    crop.y * scaleY,
    crop.width * scaleX,
    crop.height * scaleY,
    0,
    0,
    crop.width,
    crop.height
  );

  // As Base64 string
  const base64Image = canvas.toDataURL('image/jpeg');
  return base64Image;

  // As a blob
  // return new Promise((resolve, reject) => {
  //   canvas.toBlob(
  //     blob => {
  //       blob.name = fileName;
  //       resolve(blob);
  //     },
  //     'image/jpeg',
  //     1
  //   );
  // });
}

export const getImageUrl = (dbImageUrl) => {
  if (!dbImageUrl) {
    return null;
  }
  return dbImageUrl;
  // const filesIndex = dbImageUrl.search('/files');
  // if (filesIndex === -1) {
  //   return dbImageUrl;
  // }
  // const imageUrl = dbImageUrl.substring(filesIndex); // +6 to remove '/files'
  // return config.hostUrl + imageUrl;
};

export const getVideoUrl = (dbVideoUrl) => {
  if (dbVideoUrl.startsWith('http')) {
    return dbVideoUrl;
  }
  return config.hostUrl + dbVideoUrl;
};
